import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";
import useTableSort from "components/Table/useTableSort";
import { ExternalIntegration, SearchQueryOrderDirection } from "types/generated";

import {
  SERVICE_NOW_COLUMN_ID,
  SERVICE_NOW_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortServiceNowIntegrations } from "./helpers";

export const useSortingServiceNow = (integrations: ExternalIntegration[] = []) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: SERVICE_NOW_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: SERVICE_NOW_COLUMN_ID.NAME,
    initialSortDirection: SearchQueryOrderDirection.Asc,
  });

  const filteredIntegrations = useMemo(() => {
    let filtered = [...integrations];

    if (searchInput) {
      filtered = filtered.filter((integration) =>
        integration.name.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    if (sortDescriptor.column) {
      filtered = sortServiceNowIntegrations(filtered, sortDescriptor);
    }

    return filtered;
  }, [integrations, searchInput, sortDescriptor]);

  return {
    filteredIntegrations,
  };
};
